module.exports = __webpack_public_path__ + "media/images/welcome-a140fc51ffbf9a191f8e4c09a4d50667.png";